export default __webpack_public_path__ + "static/media/most-popular-artwork-5.fca00e14.png";